import React, { useEffect, useState } from 'react'
import asideModalStore from 'Stores/asideModalStore'
import st from './AddPricesInHoursModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'
import SelectCustom from '../../../Global/Select/SelectCustom'
import { superAxiosRequest } from 'axiosApi'

const values = [
  { id: 1, name: 'Пакетные цены' },
  { id: 2, name: 'Почасовые цены' },
]

const hoursType = [
  { id: 1, name: 'Academic' },
  { id: 2, name: 'Astronomical' },
]

const AddPricesInHoursModal = ({ isEdit }) => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore
  const [locations, setLocations] = useState(null)

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'accounts/employers_catalog',
    })
      .then((res) => {
        setLocations(res.data.locations.items)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  const handleSelectChange = (selectedOptions) => {
    const selectedValues = Array.isArray(selectedOptions)
      ? selectedOptions.map((option) => option.id)
      : selectedOptions
        ? [selectedOptions.id]
        : []

    changeValue(selectedValues, 'locations')
  }

  return (
    <div className={st.fieldSet}>
      <FormField>
        <FormLabel isRequired>Название:</FormLabel>
        <FormInput isError={check('name')}>
          <input
            type='text'
            placeholder={'Название'}
            name='name'
            value={modalValue?.name || ''}
            onChange={(e) => changeValue(e.target.value, 'name')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel isRequired>Сумма:</FormLabel>
        <FormInput isError={check('price_sum')}>
          <input
            type='number'
            placeholder={'Сумма'}
            name='price_sum'
            value={modalValue?.price_sum || ''}
            onChange={(e) => changeValue(e.target.value, 'price_sum')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel isRequired>Тип:</FormLabel>
        <SelectCustom
          placeholder={'Тип'}
          options={values}
          valueID={modalValue.type}
          onChange={(o) => changeValue(o.id, 'type')}
          error={check('type')}
        />
      </FormField>
      <FormField>
        <FormLabel isRequired>Тип часов:</FormLabel>
        <SelectCustom
          placeholder={'Тип часов'}
          options={hoursType}
          valueID={isEdit ? modalValue?.hours_type.id : modalValue?.hours_type}
          onChange={(o) => changeValue(o.id, 'hours_type')}
          error={check('hours_type')}
        />
      </FormField>
      <FormField>
        <FormLabel isRequired>Всего часов:</FormLabel>
        <FormInput isError={check('hours_sum')}>
          <input
            type='number'
            placeholder={'Всего часов'}
            name='hours_sum'
            value={modalValue?.hours_sum || ''}
            onChange={(e) => changeValue(e.target.value, 'hours_sum')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel isRequired>Локация:</FormLabel>
        <SelectCustom
          placeholder={'Локация'}
          optionLabelKey={'name'}
          options={locations}
          valueID={modalValue.locations || []}
          onChange={handleSelectChange}
          error={check('locations')}
          isMulti
        />
      </FormField>
    </div>
  )
}

export default observer(AddPricesInHoursModal)
